// mockPersonnelData.js — Mock personnel data for PersonnelMetrics page.
// Structure mirrors what a real SQL / D365 API response would return.
// Replace with live API calls when backend is ready.

const MOCK_PERSONNEL = [
  {
    employeeId: "101024",
    fullName: "Charles Parker",
    department: "QC",
    team: "QC",
    currentZone: "Station 8",
    currentJob: "Quality Check",
    lastUpdated: "2026-04-23 14:29",
    tagBatteryPct: 95,
    indirectMinutes: 60,
    avgTaskDurationMins: 77,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "Completed",
        duration: "60m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000027584",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000042222",
        status: "Completed",
        duration: "301m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:54",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: [
        "Station 4",
        "Station 5",
        "Station 6",
        "Station 7",
        "Station 8",
      ],
      totalActiveTime: "7h 32m",
      totalIdleTime: "0h 28m",
    },
  },
  {
    employeeId: "100951",
    fullName: "Dominic Festa",
    department: "QC",
    team: "QC",
    currentZone: "Station 20",
    currentJob: "Quality Check",
    lastUpdated: "2026-04-23 14:29",
    tagBatteryPct: 92,
    indirectMinutes: 60,
    avgTaskDurationMins: 73,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "Completed",
        duration: "60m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000027584",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000042222",
        status: "Completed",
        duration: "301m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:50",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: [
        "Station 14",
        "Station 15",
        "Station 16",
        "Station 17",
        "Station 20",
      ],
      totalActiveTime: "7h 32m",
      totalIdleTime: "0h 28m",
    },
  },
  {
    employeeId: "C100308",
    fullName: "Hailey Spence",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "WELD",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-04-23 14:26",
    tagBatteryPct: 15,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041530",
        status: "Completed",
        duration: "206m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041539",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WELD"],
      totalActiveTime: "6h 10m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "100971",
    fullName: "Adrian Hernandez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 4",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-04-23 14:28",
    tagBatteryPct: 42,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043785",
        status: "Completed",
        duration: "107m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043788",
        status: "Completed",
        duration: "124m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043749",
        status: "Completed",
        duration: "118m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043761",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 36m",
    },
  },
  {
    employeeId: "100950",
    fullName: "Jesus Felix",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 16",
    currentJob: "Insulation",
    lastUpdated: "2026-04-23 14:18",
    tagBatteryPct: 74,
    indirectMinutes: 5,
    avgTaskDurationMins: 24,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000027526",
        status: "Completed",
        duration: "93m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "90m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "98m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000042381",
        status: "Completed",
        duration: "105m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000042346",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17", "Station 20"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "0h 06m",
    },
  },
  {
    employeeId: "101245",
    fullName: "Juan De Dios Felix",
    department: "Exterior Finishing",
    team: "EXTERIORS",
    currentZone: "Station 12",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-04-23 14:22",
    tagBatteryPct: 67,
    indirectMinutes: 6,
    avgTaskDurationMins: 48,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043201",
        status: "Completed",
        duration: "18m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043215",
        status: "Completed",
        duration: "112m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043228",
        status: "Completed",
        duration: "95m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043234",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043241",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12", "Station 13"],
      totalActiveTime: "6h 15m",
      totalIdleTime: "0h 13m",
    },
  },
  {
    employeeId: "101089",
    fullName: "Juan Pablo Alarcon",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 6",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-04-23 14:19",
    tagBatteryPct: 81,
    indirectMinutes: 5,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043571",
        status: "Completed",
        duration: "22m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043584",
        status: "Completed",
        duration: "118m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043592",
        status: "Completed",
        duration: "125m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043608",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5", "Station 6"],
      totalActiveTime: "6h 28m",
      totalIdleTime: "1h 00m",
    },
  },
  {
    employeeId: "101156",
    fullName: "Lorexy Quintero",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 19",
    currentJob: "Final Plumbing",
    lastUpdated: "2026-04-23 14:16",
    tagBatteryPct: 58,
    indirectMinutes: 8,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044134",
        status: "Completed",
        duration: "48m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044141",
        status: "Completed",
        duration: "149m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044157",
        status: "Completed",
        duration: "121m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044163",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 18", "Station 19", "Station 20"],
      totalActiveTime: "6h 45m",
      totalIdleTime: "0h 43m",
    },
  },
  {
    employeeId: "101178",
    fullName: "Maria Gutierrez",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 20",
    currentJob: "Final Electrical",
    lastUpdated: "2026-04-23 14:12",
    tagBatteryPct: 72,
    indirectMinutes: 4,
    avgTaskDurationMins: 38,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044215",
        status: "Completed",
        duration: "128m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044228",
        status: "Completed",
        duration: "52m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044234",
        status: "Completed",
        duration: "85m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044241",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 17", "Station 18", "Station 20"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "1h 10m",
    },
  },
  {
    employeeId: "101064",
    fullName: "Samuel Watts",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-04-23 14:09",
    tagBatteryPct: 64,
    indirectMinutes: 10,
    avgTaskDurationMins: 56,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043173",
        status: "Completed",
        duration: "119m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043153",
        status: "Completed",
        duration: "58m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043154",
        status: "Completed",
        duration: "93m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000044334",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 36m",
    },
  },
  {
    employeeId: "104914",
    fullName: "Rosselis Borges",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 12",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-04-23 14:07",
    tagBatteryPct: 79,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044428",
        status: "Completed",
        duration: "214m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044434",
        status: "Completed",
        duration: "208m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044441",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 10", "Station 11", "Station 12"],
      totalActiveTime: "6h 35m",
      totalIdleTime: "0h 53m",
    },
  },
  {
    employeeId: "C100254",
    fullName: "Joe Hernandez",
    department: "HVAC",
    team: "HVAC",
    currentZone: "Station 8",
    currentJob: "Fire Protection / Sprinkler",
    lastUpdated: "2026-04-23 14:05",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 67,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046295",
        status: "Completed",
        duration: "98m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046698",
        status: "Completed",
        duration: "302m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046663",
        status: "In Progress",
        duration: "-",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 2,
      stationsVisited: ["Station 7", "Station 8"],
      totalActiveTime: "4h 15m",
      totalIdleTime: "1h 13m",
    },
  },
  {
    employeeId: "100985",
    fullName: "Robert Bauder",
    department: "Yard",
    team: "YARD",
    currentZone: "Station 24",
    currentJob: "Supervisor Tasks",
    lastUpdated: "2026-04-23 14:06",
    tagBatteryPct: 88,
    indirectMinutes: 435,
    avgTaskDurationMins: 193,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Supervisor Tasks",
        jobId: "JOB000027583",
        status: "Completed",
        duration: "184m",
      },
      {
        jobName: "Supervisor Tasks",
        jobId: "JOB000027583",
        status: "Completed",
        duration: "241m",
      },
      {
        jobName: "Supervisor Tasks",
        jobId: "JOB000027583",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 24"],
      totalActiveTime: "7h 16m",
      totalIdleTime: "0h 11m",
    },
  },
  {
    employeeId: "101203",
    fullName: "Zach Herbstreith",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 11",
    currentJob: "Plumbing Rough-In",
    lastUpdated: "2026-04-23 14:08",
    tagBatteryPct: 71,
    indirectMinutes: 10,
    avgTaskDurationMins: 158,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044701",
        status: "Completed",
        duration: "156m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044715",
        status: "Completed",
        duration: "162m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044734",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13", "Station 14"],
      totalActiveTime: "6h 42m",
      totalIdleTime: "0h 26m",
    },
  },
  {
    employeeId: "100962",
    fullName: "Samuel Godinez",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 15",
    currentJob: "Gypsum and Install Boundary/Upper Ceiling",
    lastUpdated: "2026-04-23 14:10",
    tagBatteryPct: 83,
    indirectMinutes: 10,
    avgTaskDurationMins: 28,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000046405",
        status: "Completed",
        duration: "197m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044857",
        status: "Completed",
        duration: "183m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044863",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "5h 30m",
      totalIdleTime: "0h 26m",
    },
  },
  {
    employeeId: "101211",
    fullName: "Sheila Brown",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Warehouse Work",
    lastUpdated: "2026-04-23 14:13",
    tagBatteryPct: 90,
    indirectMinutes: 447,
    avgTaskDurationMins: 447,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Warehouse Work",
        jobId: "JOB000044957",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE", "Station 20", "Station 24"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "100988",
    fullName: "Alfredo Hernandez",
    department: "Roofing",
    team: "ROOF",
    currentZone: "Station 9",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-04-23 14:15",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 240,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000045015",
        status: "Completed",
        duration: "258m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000045028",
        status: "In Progress",
        duration: "-",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 8", "Station 9"],
      totalActiveTime: "5h 38m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "104146",
    fullName: "Dylan Munoz",
    department: "Rough Electrical",
    team: "ROUGH ELEC",
    currentZone: "Station 6",
    currentJob: "Electrical Rough-In",
    lastUpdated: "2026-04-23 14:15",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 255,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046329",
        status: "Completed",
        duration: "261m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046695",
        status: "In Progress",
        duration: "-",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 6", "Station 7", "Station 8", "Station 9"],
      totalActiveTime: "5h 38m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "100913",
    fullName: "Jesus Aguilar Parra",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-04-23 13:33",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 51,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000043909",
        status: "Completed",
        duration: "154m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045034",
        status: "Completed",
        duration: "228m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045041",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD", "WELD", "Station 4"],
      totalActiveTime: "6h 23m",
      totalIdleTime: "0h 10m",
    },
  },
  {
    employeeId: "100934",
    fullName: "Clara Castillo",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Build Material Fabrication",
    lastUpdated: "2026-04-23 13:33",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 31,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "38m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "38m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046925",
        status: "In Progress",
        duration: "—",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046925",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 11,
      jobsInProgress: 2,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 15", "Station 16", "CAB"],
      totalActiveTime: "5h 43m",
      totalIdleTime: "0h 23m",
    },
  },
];

export default MOCK_PERSONNEL;
